<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col sm="4" md="3" lg="2" class="pa-0 d-none d-sm-block">
          <SideMenu/>
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="10" class="nav-right pa-0 py-5 pl-sm-14">
          <v-parallax height="auto" src="@/assets/images/back-page.webp">
            <div class="users webform">
              <v-form ref="form" lazy-validation>
                <v-row class="pa-0">
                  <v-col cols="12" class="pa-0">
                    <v-card ref="form" color="transparent" class="form-card py-4">
                      <div class="text-left">
                        <v-container class="px-6 py-10 mx-3 mx-xl-0">
                          <v-row>
                            <v-card flat class="users-card px-6 my-3" color="#e2f7ff">
                              <h1 class="users__title mb-6">
                                Usuarios de {{ getUser.organization.name }}
                              </h1>
                              <p class="pb-6">
                                Puedes invitar a otras personas de tu organización a trabajar en los procesos que tu administras. Envíales una invitación por correo y asígnales el rol que creas necesario. Agrega a todos los usuarios que necesites ingresando su email.
                              </p>
                              <v-card flat class="users__inner-card pa-4">
                                <h2 class="pb-1">
                                  Crea usuarios en tu cuenta
                                </h2>
                                <p>
                                  Puedes agregar los usuarios que necesitas y sin limites ingresando su e-mail.
                                </p>
                                <v-row justify="center" align="center">
                                  <v-col cols="12" sm="10" md="5" lg="5">
                                    <h3 class="ma-0 pa-0">
                                      Invita a un usuario, ingresa su e-mail
                                    </h3>
                                    <v-text-field
                                      ref="email"
                                      name="email"
                                      v-model="creating.email"
                                      placeholder="E-Mail"
                                      class="py-2"
                                      :error-messages="emailErrors"
                                      @input="$v.creating.email.$touch()"
                                      @blur="$v.creating.email.$touch()"
                                      required
                                    />
                                  </v-col>
                                  <v-col cols="12" sm="10" md="3" lg="3">
                                    <h3 class="ma-0 pa-0">
                                      Selecciona su rol
                                    </h3>
                                    <v-select
                                      ref="roles"
                                      name="roles"
                                      placeholder="Selecciona Rol"
                                      class="py-2"
                                      v-model="creating.roleName"
                                      :items="roles.names"
                                      :error-messages="roleErrors"
                                      @input="$v.creating.roleName.$touch()"
                                      @blur="$v.creating.roleName.$touch()"
                                    />
                                  </v-col>
                                  <v-col cols="12" sm="10" md="4" lg="4">
                                    <v-btn 
                                      block
                                      color="info" 
                                      large @click="invite" 
                                      :loading="loading" 
                                      :disabled="$v.$invalid || loading" 
                                      class="ma-0 d-block btn-form"
                                    >
                                      ENVIAR INVITACIÓN
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card>
                              <p class="error pt-3 pb-2 px-2" v-if="remoteError">{{ remoteError }}</p>
                            </v-card>
                          </v-row>
                          <v-data-table
                            :headers="headers"
                            :items="users"
                            class="users-table"                                                            
                            :items-per-page="10"
                            :footer-props="tableFooterProps"
                          >
                            <template v-slot:top>
                              <v-toolbar flat>
                                <v-dialog v-model="removeFlag" max-width="600px">
                                  <v-card>
                                    <v-card-title>
                                      ¿Estás seguro que quieres eliminar al usuario {{ selected.item.name }}?
                                    </v-card-title>
                                    <v-card-actions>
                                      <v-spacer />
                                      <v-btn color="info" text @click="close">Cancelar</v-btn>
                                      <v-btn color="info" text @click="remove">OK</v-btn>
                                      <v-spacer />
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                                <v-dialog v-model="updateFlag" max-width="600px">
                                  <v-card>
                                    <v-card-title>
                                      <p>
                                        ¿Estas seguro quieres resetear la contraseña del usuario {{ selected.item.name }}
                                        y solicitar una nueva a su correo electrónico?
                                      </p>
                                    </v-card-title>
                                    <v-card-actions>
                                      <v-spacer />
                                      <v-btn color="info" text @click="close">Cancelar</v-btn>
                                      <v-btn color="info" text @click="update">OK</v-btn>
                                      <v-spacer />
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </v-toolbar>
                            </template>
                            <template v-slot:[`item.title`]="{ item }">
                              <span v-html="item.title"></span>
                            </template>
                            <template v-slot:[`item.state`]="{ item }">
                              <v-select 
                                v-if="showState(item)"
                                filled
                                dense
                                @change="stateChange(item)"
                                autowidth
                                v-model="item.state"
                                :items="states.names.slice(1)"
                              />
                              <p class="text--secondary" v-else>{{item.state}}</p>
                            </template>
                            <template v-slot:[`item.roleName`]="{ item }">
                              <v-select
                                filled
                                dense
                                @change="roleChange(item)"
                                v-model="item.roleName"
                                :items="roles.names"
                              />
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                              <v-icon @click="select(item); updateFlag = true;">
                                mdi-reload
                              </v-icon>
                              <v-icon @click="select(item); removeFlag = true;">
                                mdi-delete
                              </v-icon>
                            </template>
                          </v-data-table>  
                        </v-container>
                      </div>
                    </v-card>      
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-parallax>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
import { userComputed } from "@/store/helpers.js";
import SideMenu from "@/components/SideMenu";
import { validationMixin } from "vuelidate";
import {
    required,
    email,
} from "vuelidate/lib/validators";
import { meta } from "@/libs/mixins";

export default {
    name: "OrganizationUsers",

    components: {
        SideMenu
    },

    props: ["users"],
    
    mixins: [validationMixin, meta],

    metaInfo() {
        return this.getMetaInfo({
            title: `Usuarios de ${ this.getUser.organization.name }`,
        });
    }, 

    data() {
        return {
            tableFooterProps: {
                showFirstLastPage: true,
                firstIcon: "mdi-arrow-collapse-left",
                lastIcon: "mdi-arrow-collapse-right",
                prevIcon: "mdi-minus",
                nextIcon: "mdi-plus",
                "items-per-page-text": "Usuarios por página"
            },
            headers: [
                {
                    text: "Nombre",
                    align: "start",
                    value: "title",
                    width: "30%"
                }, { 
                    text: "Estado", 
                    value: "state",
                    width: "20%"
                }, { 
                    text: "Rol", 
                    value: "roleName",
                    width: "20%"
                }, { 
                    text: "Último acceso", 
                    value: "access" 
                }, { 
                    text: "Acciones", 
                    value: "actions",
                    sortable: false
                }
            ],
            items: null,
            roles: {
                names: ["Administrador(a)"],     // Se habilitara luego de validar las caracteristicas de  los roles: "Consultor(a)", "Entrevistador(a)", "Revisor(a)" ],
                codes: ["admin"],                // Se habilitara luego de validar las caracteristicas de  los roles: "consultant", "interviewer", "reviewer" ]
            },
            states: {
                names: ["Invitación enviada", "Activo", "Inactivo"],
                codes: ["invite", "active", "inactive"]
            },
            removeFlag: false,
            updateFlag: false,
            loading: false,
            creating: {
                email: "",
                role: ""
            },
            selected: {
                item: {
                    name: ""
                }
            },
            errors: []
        };
    },

    created() {
        this.users.forEach((user) => {
            user = this.format(user);
        });
        // esto se hace, para que la tabla se actualice //
        this.items = this.users;
    },

    computed: {
        ...userComputed,
        emailErrors() {
            const errors = [];
            if (!this.$v.creating.email.$dirty) return errors;
            !this.$v.creating.email.email && errors.push("Se debe ingresar e-mail valido");
            !this.$v.creating.email.required && errors.push("E-mail es requerido");
            return errors;
        },
        roleErrors() {
            const errors = [];
            if (!this.$v.creating.roleName.$dirty) return errors;
            !this.$v.creating.roleName.required && errors.push("El rol es requerido");
            return errors;
        },
        remoteError() {
            let err = "";
            if (this.errors.length > 0)
                err = this.errors[this.errors.length - 1];

            if (err.includes("INGRESA DESDE INICIAR SESIÓN O RESTABLECE TU CONTRASEÑA")) {
                err = "ESTE CORREO YA ESTÁ REGISTRADO.";
            }
            return err;
        },
    },

    methods: {
        format(user) {
            /// TODO mejorar formateo de tarjetas ///
            user.title = "<h4 class=\"text--primary\">" + user.name + "</h4>";
            user.title += "<p class=\"text--secondary\">" + user.email + "</p>";
            user.state = this.states.names[this.states.codes.indexOf(user.status)];
            user.roleName = this.roles.names[this.roles.codes.indexOf(user.role)];
            return user;
        },
        invite() {
            this.loading = true;
            this.errors = [];
            this.$store.dispatch("users/invite", {
                email: this.creating.email,
                role: this.roles.codes[this.roles.names.indexOf(this.creating.roleName)],
                organizationId: this.getUser.organization.id
            }).then((response) => {
                this.loading = false;
                this.users.unshift(this.format({
                    id: response.userId,
                    name: "-",
                    status: "invite",
                    email: this.creating.email, 
                    role: this.roles.codes[this.roles.names.indexOf(this.creating.roleName)],
                    access: "--"
                }));

                this.$v.$reset();
                this.creating = {
                    email: "",
                    role: ""
                };
                
                // esto se hace, para que la tabla se actualice //
                this.items = null;
                this.items = this.users;
            }).catch(err => {
                this.loading = false;
                this.errors = err;
            });
        },
        select(item) {
            this.selected.index = this.users.indexOf(item);
            this.selected.item = Object.assign({}, item);
        },
        update() {
            this.$store.dispatch("users/forgetPassword", {
                email: this.selected.item.email
            }).then(() => {
            }).catch(err => {
                this.errors = err;
            });

            this.selected.item = {
                name: ""
            };            
            this.selected.index = -1;
            this.updateFlag = false;
        },
        remove() {
            this.$store.dispatch("users/remove", {
                userId: this.selected.item.id,
                email: this.selected.item.email
            }).then(() => {
                this.users.splice(this.selected.index, 1);
                this.selected.item = {
                    name: ""
                };
                this.selected.index = -1;
                this.removeFlag = false;
            }).catch(err => {
                this.errors = err;
                this.selected.item = {
                    name: ""
                };
                this.selected.index = -1;
                this.removeFlag = false;
            });
        },
        close() {
            this.removeFlag = false;
            this.updateFlag = false;
            this.$nextTick(() => {
                this.selected.item = {
                    name: ""
                };
                this.selected.index = -1;
            });
        },
        roleChange(item) {
            this.$store.dispatch("users/update", {
                id: item.id,
                email: item.email,
                role: this.roles.codes[this.roles.names.indexOf(item.roleName)]
            }).catch(err => {
                this.loading = false;
                this.errors = err;
            });
        },
        stateChange(item) {
            this.$store.dispatch("users/update", {
                id: item.id,
                email: item.email,
                status: this.states.codes[this.states.names.indexOf(item.state)]
            }).catch(err => {
                this.loading = false;
                this.errors = err;
            });
        },
        showState(item) {
            return item.status != "invite";
        }
    },  
    
    validations: {
        resume: {},
        creating: {
            email: { required, email },
            roleName: { required },
        }
    },
};
</script>

<style scoped>
.users-card {
    background: #e2f7ff;
    border-radius: 10px;
    padding: 20px;
}
.users-card h2{
    font-size: 16px;
    font-family: "Circular";
    color: #26253C;
}
.users-card h3{
    font-size: 14px;
    font-family: "Circular";
    color: #26253C;
}
.users-card p{
    font-size: 16px;
    font-family: "Circular";
    font-weight: normal;
    color: #26253C;
}
.v-data-table {
    background-color: transparent;
}
.v-select {
    font-size: 14px;
    font-family: "Circular";
    font-weight: normal;
}
.users-table{
    table-layout : fixed;
}
</style>
